import type { Session } from "@supabase/supabase-js";
import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { supabase } from "../lib/supabase";
import s from "./Reviewer.module.css";
import { VagasList } from "./VagasList";
import { VagaDetail } from "./VagaDetail";
import { TesteDetail } from "./TesteDetail";
import { CandidateReview } from "./CandidateReview";
import { Invites } from "./Invites";

export function ReviewerApp({ session }: { session: Session }) {
  const email = session.user.email || "";
  const isReachup = email.toLowerCase().endsWith("@reachup.pro");

  if (!isReachup) {
    return (
      <div className="splash" style={{ flexDirection: "column", gap: "var(--s-3)" }}>
        <p>Acesso restrito a contas @reachup.pro.</p>
        <button className="btn btn-ghost" onClick={() => supabase.auth.signOut()}>Sair</button>
      </div>
    );
  }

  return (
    <div className={s.shell}>
      <nav className={s.nav}>
        <span className={s.brand}>Reach Up · RH</span>
        <NavLink to="/admin" end className={({ isActive }) => (isActive ? s.active : "")}>Vagas</NavLink>
        <NavLink to="/admin/convites" className={({ isActive }) => (isActive ? s.active : "")}>Convites</NavLink>
        <span className={s.spacer} />
        <span className={s.who}>{email}</span>
        <button className="btn btn-ghost" style={{ padding: "4px 12px" }} onClick={() => supabase.auth.signOut()}>Sair</button>
      </nav>
      <Routes>
        <Route index element={<VagasList />} />
        <Route path="vaga/:role" element={<VagaDetail />} />
        <Route path="teste/:assessmentId" element={<TesteDetail email={email} />} />
        <Route path="review/:sessionId" element={<CandidateReview email={email} />} />
        <Route path="convites" element={<Invites email={email} />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </div>
  );
}
